import { FC } from "react";

import { usePlatformFeatureFlag } from "@datassential/platform-ui-lib";

import './RecentSearches.styles.scss';
import { AI_SEARCH_FEATURE_FLAG } from "../GlobalSearch";
import useRecentSearches from "../../../../core/apiHooks/useRecentSearches";

const RECENT_SEARCHES_FEATURE_FLAG = 'RPRO Recent Searches';

const RecentSearches: FC<{
	onSearch: (search: string) => void;
}> = ({ onSearch }) => {
	const { data: recentSearches } = useRecentSearches();
	const isAiSearchEnabled = usePlatformFeatureFlag(AI_SEARCH_FEATURE_FLAG);
	const isRecentSearchesEnabled = usePlatformFeatureFlag(RECENT_SEARCHES_FEATURE_FLAG);

	if (!recentSearches?.length || !isAiSearchEnabled || !isRecentSearchesEnabled) {
		return null;
	}

	return (
		<div className="RecentSearches">
			<div className="RecentSearches__title">Recent Searches</div>
			<div className="RecentSearches__list">
				{recentSearches.map((searchText) => (
					<div className="RecentSearches__item" key={searchText} onClick={() => onSearch(searchText)}>
						{searchText}
					</div>
				))}
			</div>
		</div>

	);
}

export default RecentSearches;
